import './minimal.css';
import gsap from 'gsap';

// const allSkils = document.querySelectorAll('.skillBox');
const allSkils = gsap.utils.toArray('.skillBox');
const bountries = document.querySelector('.landing');
const bountriesWidth = bountries.offsetWidth;
const bountriesHeight = bountries.offsetHeight;

gsap.set(allSkils, { xPercent: 50, yPercent: 50 });

const dx = bountriesWidth * 0.4;
const dy = bountriesHeight * 0.5;

allSkils.forEach((skill) => {
  tweenProperty(skill, 'x', -dx, dx);
  tweenProperty(skill, 'y', -dy, dy);
});

function tweenProperty(target, prop, min, max) {
  gsap.to(target, {
    [prop]: gsap.utils.random(min, max),
    duration: 'random(5, 8)',
    ease: 'none',
    onComplete: tweenProperty,
    onCompleteParams: [target, prop, min, max]
  });
}

const project1 = new Image();
project1.src = '/assets/daPortal.jpg';
project1.classList.add('projectImg');
document.querySelector('.project1').appendChild(project1);

const project2 = new Image();
project2.src = '/assets/cantine.jpg';
project2.classList.add('projectImg');
document.querySelector('.project2').appendChild(project2);

const project3 = new Image();
project3.src = '/assets/scrimba.jpg';
project3.classList.add('projectImg');
document.querySelector('.project3').appendChild(project3);
